import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { getInvite, acceptInvite } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { Shell, Card, H1, Field, Btn } from "./ui";

export default function AcceptInvite() {
  const { token } = useParams();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [invite, setInvite] = useState(null);
  const [err, setErr] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    getInvite(token).then(setInvite).catch(() => setErr("This invitation is invalid or has expired."));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await acceptInvite(token, { name, password });
      await refresh();
      toast.success("Account created");
      nav("/dashboard", { replace: true });
    } catch (er) {
      toast.error(er?.response?.data?.detail || "Could not accept invitation");
    } finally { setBusy(false); }
  };

  return (
    <Shell>
      <div className="max-w-md mx-auto mt-16">
        <H1>Accept your invitation</H1>
        {err && <Card className="mt-6" data-testid="invite-error"><p className="text-red-400 text-sm">{err}</p></Card>}
        {invite && (
          <Card className="mt-6">
            <p className="text-sm text-white/70 mb-4">You're joining <b className="text-white">{invite.tenant_name}</b> as <b className="text-[#00D26A]">{invite.role}</b> ({invite.email}).</p>
            <form onSubmit={submit} data-testid="invite-form">
              <Field label="Your name" value={name} onChange={(e) => setName(e.target.value)} data-testid="invite-name" />
              <Field label="Create a password (min 8 chars)" type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="invite-password" required />
              <Btn type="submit" disabled={busy} data-testid="invite-submit" className="w-full mt-2">{busy ? "Creating…" : "Create account"}</Btn>
            </form>
          </Card>
        )}
      </div>
    </Shell>
  );
}
